import { GroupedRequestGroup, GroupedRequestPage } from '@/core/enums/group-request.enum';
import { api } from '@/core/helpers/axiosHelper';
import { CancelToken } from 'axios';
import { SquadFilter } from '../squad-filter/squad-filter.interface';
import { Squad } from './squad.interface';

const SQUAD_ENDPOINTS = {
   GET_ALL: () => `/squad`,
};

export default {
   async get(squad_id: number, cancel_token: CancelToken) {
      return await api
         .get('/squad/' + squad_id, {
            params: {
               include: 'properties.property_type,timetable,company',
            },
            cancelToken: cancel_token,
         })
         .then((response) => {
            return response?.data;
         });
   },
   async getById(squad_id: number) {
      return await api
         .get(`/squad/${squad_id}`, {
            params: {
               include: 'timetable,city',
            },
         })
         .then((response) => response?.data);
   },
   async delete(squad_id: number) {
      return await api.delete('/squad/' + squad_id);
   },
   async patch(squad_id: number, body: Array<{ op: string; path: string; value: any }>) {
      return await api
         .patch('/squad/' + squad_id, body, { params: { include: 'board,company,properties.property_type,timetable,city' } })
         .catch((error) => Promise.reject(error?.response?.data?.errors))
         .then((response) => response.data);
   },
};
